export default {
  'error.title': 'System Error Occurred',
  'error.description':
    'Please try refreshing the page or reopening it.<br />If the issue persists, please contact on-site staff for assistance.',
} as Record<string, string>;
